import './App.css';
import { useSelector } from 'react-redux';
import { Login, Count, Todo } from './Components/Practiced';

const App = () => {
  const user = useSelector((state) => state?.user);
  return (
    <div style={{ margin: '10px' }}>
      {!user?.email ?
        <Login />
        :
        <div>
          <Count />
          <Todo />
        </div>
      }
    </div>
  )
}

export default App;

// // import "./App.css";
// // import Count from './Components/Count/Count'
// // import Todo from './Components/Count/Todo'
// // import KeyValue from './Components/Count/KeyValue'
// // import PropsDemo from "./Components/Practiced/PropsDemo";
// import { useState } from 'react'
// import Form from './Components/SubComponents/Form'
// import Students from './Components/SubComponents/Students'
// import GlobalState from './Components/context/global/GlobalState';

// const App = () => {

//   const [students, setStudents] = useState([]);

//   const addStudent = newStudent => setStudents([...students, newStudent])

//   return (
//     <GlobalState>
//       <div>
//         <h1>Axiom Student Portfolio</h1>
//         <Form />
//         <Students />
//       </div>
//     </GlobalState>
//   )
// }

// export default App;



// {/* <Count /> */ }
// {/* <Todo /> */ }
// {/* <KeyValue /> */ }
// {/* <PropsDemo obj={obj} msg={msg} count={count} /> */ }